import request, { FormDataHeader } from '@/utils/request'
import {
  UserDeviceItem,
  WarehousePoint,
  ActiveInfoItem,
  GetWarehousePointParams,
  GetDeviceActiveInfoQuery,
  PageQuery,
  RecordListPageResult,
  sumbitDeviceApplyParams,
  sumbitDeviceApplyResult,
  GetRecordDetailQuery,
  RecordDetail,
  confirmPayParameter,
  confirmPayResult,
  checkPayStatusResult,
} from '@/types/device-replace'

export function getUserDeviceList(): Promise<UserDeviceItem[]> {
  return request.get(`/api-crm/farm/exchange/index`)
}
export function sumbitDeviceApply(
  params: sumbitDeviceApplyParams
): Promise<sumbitDeviceApplyResult> {
  return request.post('/api-crm/farm/exchange/save', params)
}
export function getWarehousePointList(params: GetWarehousePointParams): Promise<WarehousePoint[]> {
  return request.get('/api-crm/farm/exchange/client', { params })
}
export function getDeviceActiveInfo(params: GetDeviceActiveInfoQuery): Promise<ActiveInfoItem[]> {
  return request.get('/api-crm/farm/exchange/activity', { params })
}
export function getApplyRecordList(params: PageQuery): Promise<RecordListPageResult> {
  return request.get('/api-crm/farm/exchange/list', { params })
}
export function getApplyRecordDetail(params: GetRecordDetailQuery): Promise<RecordDetail> {
  return request.get('/api-crm/farm/exchange/detail', { params })
}
export function cancelOrder(params: { guid: string }): Promise<void> {
  return request.post('/api-crm/farm/exchange/cancel', params, {
    headers: FormDataHeader,
  })
}
export function confirmPayOrder(params: confirmPayParameter): Promise<confirmPayResult> {
  return request.post('/api-crm/farm/exchange/pay', params)
  // return new Promise((resolve) => {
  //   resolve({
  //     order_no: '123456',
  //     order_guid: '11',
  //     invoice_apply_guid: '11',
  //   })
  // })
}
export function checkPayOrderStatus(params: { order_no: string }): Promise<checkPayStatusResult> {
  return request.get('/api-crm/farm/exchange/pay_status', { params })
  // return new Promise((resolve) => {
  //   setTimeout(() => {
  //     resolve({
  //       guid: 'string',
  //       order_no: 'string',
  //       pay_sn: 'string',
  //       status: 1,
  //       pay_status: 1, // 1-支付成功 0-未支付
  //     })
  //   }, 2000)
  // })
}
export function confirmReceiveProduct(params: { guid: string }): Promise<void> {
  return request.get('/api-crm/farm/exchange/receipt', { params })
}
